import React, { useEffect, useState } from "react";
import { Modal, Tooltip } from 'antd';
import styles from "./scss/videorecordtlist.module.scss";
import store from "../../../../context/store/store";
import moment from 'moment';
import noResult from "../../../../styles/images/empty_states/empty-nofound.svg";
import groovyWalkAnimation from "../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../styles/images/Lottie Animation.json";
import {
  copyLink,
  downloadFile,
  fetchClips,
  findRecHost,
  getDuration,
  timeStampConverterMeeting,
  VideoRecordDelete
} from '../../../../base/callService/common';
import { bytesToSize } from "../../../../base/utils";
import { saverecordlist, shareRedux } from "../../../../base/socketChatService/newChat";
import { URChatLeftSkeleton } from "../../../../shared/skeletonLoading/chatLeftSkeleton";
import NoContent from "../../../../shared/widgets/noContent";
import Lottie from "lottie-react";

type recordstate ={
  deleteRecordModal:boolean;
}
export default function RecordvideoLists() {
  const [recordlist, setRecordlist] = useState([]);
  const {videoRecordingList,recLoad}=store.getState().meetingReducer;
  const [getrecData, setRecData] = useState<recordstate>({deleteRecordModal:false});
  useEffect (()=>{
    setRecordlist(videoRecordingList);
  },[videoRecordingList])


  const recordinglist =(record:any)=>{
    saverecordlist(record)
  }

  const shareFile=(record:any)=>{
    shareRedux(record,true);
  }

  const DeleteRecord =() =>{
    // VideoRecordDelete();
    setRecData({...getrecData, deleteRecordModal:false})
 
  }

  const confirmDelete = () => {
    setRecData({...getrecData, deleteRecordModal:true})
  };
  const closeSelection = () => {
    setRecData({...getrecData, deleteRecordModal:false})
  };
  return (
    <>
   {recordlist && Array.isArray(recordlist) && recordlist?.length > 0 ? recordlist.map((record : any, index : any)=>{
    return(
      <div className={styles.videorecordlist}  key={index}>
      {moment(new Date(record?.createdate)?.toString())?.format('YYYY/MM/DD') !==
              moment(new Date (recordlist [index -1]?.createdate).toString())?.format('YYYY/MM/DD') && <span className={styles.daylist}>{timeStampConverterMeeting(new Date(record.createdate).toString(), 'group')}</span>}
      <>
      <div className={`${styles.recsection} ${styles.active}`}  onClick={()=>recordinglist(record)}>
          <div className={styles.hoversection}>
            <ul>
              <Tooltip placement="top" title={'Link'}><li><span className="icon_linkrotate"  onClick={()=>copyLink(record.record_url)}></span></li></Tooltip>
              <Tooltip placement="top" title={'Download'}><li>
                <span className="icon_Downloadstroke" onClick={()=>downloadFile(record)}></span></li></Tooltip>
              <Tooltip placement="top" title={'Share'}><li><span className="icon_reply"  onClick={()=>shareFile(record)}></span></li></Tooltip>
              <Tooltip placement="top" title={'Delete'}><li><span className="icon_delete"  onClick={confirmDelete}></span></li></Tooltip>
            </ul>
          </div>
          <h3>{record.meeting_name}</h3>
          <div className={styles.bottom}>
            <div className={styles.hours}>
              <p>{getDuration(record.duration)}</p>
            </div>
            <div className={styles.names}>
              <p><span className="icon_profile"></span>{findRecHost(JSON.parse(record.urmeet_user_list))}</p>
            </div>
            <div className={styles.filesize}>
              <p>{bytesToSize(record.record_size)}</p>
            </div>
          </div>
        </div>
        </>


   


      </div>
    )
   }) :
   <> {recLoad ?
    <>{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((index: any) => (
      <div key={index}><URChatLeftSkeleton />
      </div>
    ))}</> : <NoContent image={noResult}
      title={''}
      description={'No meetings found'} />} </>
   }
    {recLoad && recordlist?.length >  0 &&  <div className="skeletonMeetingbottom "><Lottie className="svgLoading"
 animationData={ContactLoader} /></div> }
   
   <Modal title="Delete Recorded video?"
        centered
        maskClosable={false}
        visible={getrecData.deleteRecordModal}
        onOk={DeleteRecord}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected Recorded Video?
      </Modal>
    </>
  );
};

